import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, forkJoin, map, Observable, throwError } from 'rxjs';
import {
  TokenCheck,
  TokenConfiguration,
  UtilitiesService,
} from './utilities.service';

@Injectable({
  providedIn: 'root',
})
export class VerifierService {
  private http = inject(HttpClient);
  private utilitiesService = inject(UtilitiesService);

  public figmaAccess(
    accessToken: string,
    projectId: string
  ): Observable<unknown> {
    return this.http.head(`https://api.figma.com/v1/files/${projectId}`, {
      headers: {
        'X-Figma-Token': accessToken,
      },
    });
  }

  public checkTokens(
    accessToken: string,
    projectId: string,
    foundationTokenNodeId: string,
    colorTokenNodeId: string
  ): Observable<TokenCheck> {
    const foundationRequest = this.http.get(
      `https://api.figma.com/v1/files/${projectId}/nodes?ids=${foundationTokenNodeId}`,
      {
        headers: {
          'X-Figma-Token': accessToken,
        },
      }
    );

    const colorRequest = this.http.get(
      `https://api.figma.com/v1/files/${projectId}/nodes?ids=${colorTokenNodeId}`,
      {
        headers: {
          'X-Figma-Token': accessToken,
        },
      }
    );

    return forkJoin([foundationRequest, colorRequest]).pipe(
      map(([foundationData, colorData]) => {
        const tokenCheck = this.utilitiesService.preCheckTokens(
          foundationData,
          colorData
        );

        return tokenCheck;
      }),
      catchError((error) => {
        console.error('Error during preCheck:', error);
        return throwError(() => error);
      })
    );
  }

  public validateComponent(
    accessToken: string,
    projectId: string,
    componentNodeId: string,
    tokenConfiguration: TokenConfiguration
  ): Observable<string[]> {
    return this.http
      .get(
        `https://api.figma.com/v1/files/${projectId}/nodes?ids=${componentNodeId}`,
        {
          headers: {
            'X-Figma-Token': accessToken,
          },
        }
      )
      .pipe(
        map((figmaTree: any) => {
          const nodeKeys = Object.keys(figmaTree['nodes']);
          let components = this.utilitiesService.getComponents(
            figmaTree['nodes'][nodeKeys[0]].document
          );

          const parsedData = this.utilitiesService.parseTreeNode(components);

          return this.utilitiesService.validateComponents(
            parsedData,
            tokenConfiguration
          );
        }),
        catchError((error) => {
          console.error('Error during component validation:', error);
          return throwError(() => error);
        })
      );
  }
}
